import React from "react";
import type { DrawnPartition, XY } from "../../../lib/geo/types";

type Props = {
  width: number;
  height: number;
  partitions: DrawnPartition[];
  currentStroke: XY[] | null;
  color: string;
};

const makeFill = (hex: string) => `${hex}33`; // ~20% alpha

export default function PartitionsLayer({
  width,
  height,
  partitions,
  currentStroke,
  color,
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      style={{ position: "absolute", inset: 0, zIndex: 1, pointerEvents: "none" }}
    >
      {partitions.map((p) => (
        <g key={p.id}>
          <path
            d={`M ${p.points.map((pt) => `${pt.x},${pt.y}`).join(" L ")} Z`}
            fill={makeFill(p.color)}
            stroke={p.color}
            strokeWidth={2}
            vectorEffect="non-scaling-stroke"
            shapeRendering="geometricPrecision"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
          {p.label && p.points.length > 0 && (
            <text
              x={p.points[0].x + 6}
              y={p.points[0].y + 6}
              fontSize={10}
              fill="#555"
              style={{ userSelect: "none" }}
            >
              {p.label}
            </text>
          )}
        </g>
      ))}

      {currentStroke && currentStroke.length > 1 && (
        <polyline
          points={currentStroke.map((pt) => `${pt.x},${pt.y}`).join(" ")}
          fill="none"
          stroke={color}
          strokeWidth={2}
          strokeDasharray="4 3"
          vectorEffect="non-scaling-stroke"
          shapeRendering="geometricPrecision"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
